/* eslint-disable react/prop-types */
import React, { Fragment } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Container,
    CardText,
} from "reactstrap"

export const ReasonModal = props => {
    return (
        <Fragment>
            <div>
                <Modal
                    size="sm"
                    isOpen={true}
                    centered
                >
                    <div
                        className="modal-header"
                        style={{ backgroundColor: "#f5f5f5", color: "black" }}
                    >
                        <h5 className="modal-title mt-0" id="myExtraLargeModalLabel">
                            Reason
                        </h5>
                        <button
                            onClick={() => {
                                props.setModalOpen(false)
                            }}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <CardBody>
                                <label className="col-form-label">Reason</label>
                                <input type={"text"} name={"reason"} className={"form-control"} onChange={
                                    e => props.setReason(e.target.value)
                                }/>
                            </CardBody>
                        </Row>
                    </div>
                    <div className="modal-footer" style={{ backgroundColor: "#f5f5f5" }}>
                        <div className="row w-100">
                            <div className="col-lg-6"></div>
                            <div className="col-lg-6">
                                <div className="d-flex" style={{float: "right"}}>
                                    <div
                                        style={{
                                            padding: "10px",
                                            backgroundColor: "#34c38f",
                                            color: "white",
                                            marginRight: "5px"
                                        }}
                                        onClick={() => {
                                          props.saveNoteWithAmount(props.functionName)
                                        }}
                                    >
                                        Save
                                    </div>
                                    <div
                                        style={{
                                            padding: "10px",
                                            backgroundColor: "#ff385e",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            props.setModalOpen(false)
                                        }}
                                    >
                                        Close
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </Fragment>
    )
}